export const MAX_PDP_DOTS = 6
